<script lang="ts">
  import { onDestroy, onMount } from "svelte";

  import {
    CurrentDay,
    selectedActivityIndex,
    urlParams,
  } from "../store/AppState";
  import ActivityBadgeBackdrop from "./ActivityBadgeBackdrop.svelte";
  import ActivityBadgeContent from "./ActivityBadgeContent.svelte";
  import ActivityCloud from "./ActivityCloud.svelte";

  export let handleClose: () => void;
  let Badge: HTMLElement;

  const keydownListener = (e: KeyboardEvent) => {
    if ($selectedActivityIndex !== null) {
      if (e.key === "Escape" && $urlParams.get("aktivita") === null) {
        onClose();
      }
      if (e.key === "ArrowLeft" && $selectedActivityIndex !== 0) {
        $selectedActivityIndex -= 1;
      }
      if (
        e.key === "ArrowRight" &&
        $selectedActivityIndex !== $CurrentDay - 1
      ) {
        if ($selectedActivityIndex !== null) {
          $selectedActivityIndex += 1;
        }
      }
    }
  };

  onMount(() => {
    window.addEventListener("keydown", keydownListener);
    setTimeout(() => {
      Badge.style.top = "50%";
    }, 100);
  });

  const onClose = () => {
    Badge.style.top = "-50%";
    setTimeout(() => {
      handleClose();
    }, 300);
    window.removeEventListener("keydown", keydownListener);
  };

  let previousIndex: null | number = null;

  const unsubscribe = selectedActivityIndex.subscribe((index) => {
    if (previousIndex !== null && previousIndex !== index && index !== null) {
      // Carousel variant
      let oldLeft: string;
      let newLeft: string;
      let transition = "top 0.6s cubic-bezier(0.34, 1.56, 0.64, 1), left 0.6s";
      if (previousIndex < index) {
        oldLeft = "-100%";
        newLeft = "200%";
      } else {
        oldLeft = "200%";
        newLeft = "-100%";
      }
      Badge.style.left = oldLeft;
      setTimeout(() => {
        Badge.style.visibility = "hidden";
        Badge.style.transition = "none";
        Badge.style.left = newLeft;
      }, 200);
      setTimeout(() => {
        Badge.style.visibility = "visible";
        Badge.style.transition = transition;
        Badge.style.left = "50%";
      }, 400);
    }
    previousIndex = index;
  });

  onDestroy(() => {
    unsubscribe();
  });
</script>

{#if $selectedActivityIndex !== null}
  <div class="badge-container">
    <ActivityBadgeBackdrop {onClose} />
    <div bind:this={Badge} class="activity-badge">
      <ActivityCloud {onClose} />
      <ActivityBadgeContent />
    </div>
  </div>
{/if}

<style>
  .activity-badge {
    top: -50%;
    z-index: 310;
    width: 90vmin;
    max-width: 70rem;
    height: 50vmin;
    margin: 0 auto;
    position: fixed;
    left: 50%;
    transform: translate(-50%, -50%);
    transition:
      top 0.6s cubic-bezier(0.34, 1.56, 0.64, 1),
      left 0.6s;
  }

  .activity-badge::before {
    position: fixed;
    content: ""; /* Required for ::before to work */
    top: -25vh; /* Position at the top of the element */
    left: 45%; /* Center the line horizontally */
    transform: translate(-50%, -50%);
    width: 0.6rem; /* Line thickness */
    height: 100vh;
    background-color: hsla(206, 41%, 83%, 1); /* Line color */
    z-index: -1;
  }
</style>
